import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth-guard.service';

import { EditionGuard } from './core/edition-guard.service';
import { ProfileGuard } from './core/profile-guard.service';
import { EntityEditableGuard } from './core/entity-editable-guard.service';
import { ResearchUnitsGuard } from './core/research-units-guard.service';
import { ApcGuard } from './core/apc-guard.service';
import { PivotGuard } from './core/pivot-guard.service';

export const routes: Routes = [
    {
        path: 'general/:page-code',
        loadChildren: () =>
            import('./generic-page/generic-page.module').then(
                (m) => m.GenericPageModule,
            ),
        data: { routeIdx: 4 },
    },
    {
        path: 'profile',
        loadChildren: () =>
            import(
                './profile/profile-standalone/profile-standalone.module'
            ).then((m) => m.ProfileStandaloneModule),
        canActivate: [AuthGuard],
        data: { routeIdx: 3 },
    },
    {
        path: 'profiles/:idx',
        loadComponent: () =>
            import('./index-page/index-page.component').then(
                (m) => m.IndexPageComponent,
            ),
        data: { indexKey: 'researchersIndex' },
    },

    {
        path: 'profiles',
        redirectTo: 'profiles/A',
    },
    {
        path: 'output/:idx',
        loadComponent: () =>
            import('./index-page/index-page.component').then(
                (m) => m.IndexPageComponent,
            ),
        data: { indexKey: 'assetsIndex' },
    },
    {
        path: 'output',
        redirectTo: 'output/A',
    },
    {
        path: 'deposit',
        loadChildren: () =>
            import('./student/student-deposit/student-deposit.module').then(
                (m) => m.StudentDepositModule,
            ),
        canActivate: [AuthGuard],
        data: { role: 'User' },
    },
    {
        path: 'login',
        loadComponent: () =>
            import('./login/login.component').then((m) => m.LoginComponent),
        data: { routeIdx: 0 },
    },
    {
        path: 'login-as',
        loadComponent: () =>
            import('./login/login-as/login-as.component').then(
                (m) => m.LoginAsComponent,
            ),
        canActivate: [AuthGuard],
        data: { routeIdx: 1 },
    },
    {
        path: 'login-error',
        loadComponent: () =>
            import(
                './login/login-error-no-researcher-role/login-error-no-researcher-role.component'
            ).then((m) => m.LoginErrorNoResearcherRoleComponent),
    },
    {
        path: 'settings',
        loadChildren: () =>
            import('./settings/settings.module').then((m) => m.SettingsModule),
        canActivate: [AuthGuard],
        data: { routeIdx: 10 },
    },
    {
        path: 'search',
        loadChildren: () =>
            import('./discovery/discovery.module').then(
                (m) => m.DiscoveryModule,
            ),
        data: { routeIdx: 'search' },
    },
    {
        path: 'profile/:id',
        canActivate: [EditionGuard, ProfileGuard],
        loadChildren: () =>
            import(
                './profile/profile-standalone/profile-standalone.module'
            ).then((m) => m.ProfileStandaloneModule),
    },
    {
        path: 'outputs',
        loadChildren: () =>
            import('./asset-page/asset-page.module').then(
                (m) => m.AssetPageModule,
            ),
    },
    {
        path: 'project',
        canActivate: [EntityEditableGuard],
        loadChildren: () =>
            import('./project/project-page/project-page.module').then(
                (m) => m.ProjectPageModule,
            ),
    },
    {
        path: 'activity',
        canActivate: [EntityEditableGuard],
        loadChildren: () =>
            import('./activities/activities-page/activities-page.module').then(
                (m) => m.ActivitiesPageModule,
            ),
    },
    {
        path: 'resource',
        canActivate: [EntityEditableGuard],
        loadChildren: () =>
            import('./resources/resource-page/resource-page.module').then(
                (m) => m.ResourcePageModule,
            ),
    },
    {
        path: 'research-units',
        canActivate: [ResearchUnitsGuard],
        loadChildren: () =>
            import('./research-units/research-units.module').then(
                (m) => m.ResearchUnitsModule,
            ),
    },
    {
        path: 'apc',
        canActivate: [AuthGuard],
        canLoad: [ApcGuard],
        loadChildren: () =>
            import('./apc-form-standalone/apc-form-standalone.module').then(
                (m) => m.ApcFormStandaloneModule,
            ),
    },
    {
        path: 'funding',
        canActivate: [AuthGuard],
        canLoad: [PivotGuard],
        loadChildren: () =>
            import('./pivot-standalone/pivot-standalone.module').then(
                (m) => m.PivotStandaloneModule,
            ),
    },
    {
        path: 'collections',
        loadComponent: () =>
            import(
                './collections/collections-browse-page/collections-browse-page.component'
            ).then((m) => m.CollectionsBrowsePageComponent),
    },
    {
        path: 'resources',
        loadChildren: () =>
            import('./resources/resources.module').then(
                (m) => m.ResourcesModule,
            ),
    },
    {
        path: 'notifications',
        canActivate: [AuthGuard],
        loadComponent: () =>
            import(
                './notifications/notifications-page/notifications-page.component'
            ).then((_) => _.NotificationsPageComponent),
        children: [
            {
                path: 'outputClaim',
                loadComponent: () =>
                    import(
                        './profile/claim-outputs/claim-outputs.component'
                    ).then((_) => _.ClaimOutputsComponent),
            },
            {
                path: 'requests',
                loadComponent: () =>
                    import(
                        './profile/requests/requests-management/requests-management.component'
                    ).then((_) => _.RequestsManagementComponent),
            },
        ],
    },
    {
        path: '',
        loadChildren: () =>
            import('./portal/portal.module').then((m) => m.PortalModule),
    },
    { path: '**', redirectTo: 'search' },
];
